const errors = {
  errorUpdatingTemplate: 'Pri posodabljanju predloge je prišlo do napake',
  errorUpdatingReport: 'Pri posodabljanju izvida je prišlo do napake',
  errorGeneratingReport: 'Pri generiranju izvida je prišlo do napake',
  errorDeletingReport: 'Pri brisanju izvida je prišlo do napake',
  errorCreatingTemplate: 'Pri ustvarjanju predloge je prišlo do napake',
  errorDeletingTemplate: 'Pri brisanju predloge je prišlo do napake',
  errorDuplicatingTemplate: 'Pri podvajanju predloge je prišlo do napake',
  errorExtractingData: 'Pri generiranju podatkov je prišlo do napake',
  errorTogglingLanguage: 'Pri spreminjanju jezika je prišlo do napake',
  versionGuard: {
    updateRequired: 'Posodobitev je zahtevana',
    updateRequiredDescription:
      'Vaša različica aplikacije ({{currentVersion}}) je zastarela. Prosimo, posodobite na različico {{minVersion}} ali novejšo za nadaljevanje uporabe aplikacije.',
    genericMessage:
      'Prosimo, posodobite na najnovejšo različico Voicefill Medical za nadaljnjo uporabo aplikacije.',
    updateButton: 'Posodobi aplikacijo',
  },
  invalidCode: 'Neveljavna koda. Poskusite znova.',
  failedToSignIn: 'Napačno geslo. Poskusite znova.',
  failedToSendCode: 'Prišlo je do napake pri pošiljanju kode',
  failedToSignInWithGitHub: 'Prijava z Github-om ni uspela',
  errorBoundary: {
    title: 'Prišlo je do napake',
    contactSupport: 'Če se težava ponovi, kontaktirajte podporo.',
    tryAgain: 'Poskusi znova',
    backHome: 'Nazaj na začetek',
  },
};

export default errors;
